
import { connect as reactReduxConnect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import _ from 'lodash';
import { ApolloLink } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';

import { curryApiToService } from '@arreeba/ristoranti-lib/lib/service';
import AppService from '@arreeba/ristoranti-frontend-lib/lib/services/app';
import BookingService from '@arreeba/ristoranti-lib/lib/service/booking';
import OrderService from '@arreeba/ristoranti-frontend-lib/lib/services/order';
import UserService from '@arreeba/ristoranti-lib/lib/service/user';
import VoucherService from '@arreeba/ristoranti-lib/lib/service/voucher';

import appAction from '@arreeba/ristoranti-frontend-lib/lib/actions/app';
import Api from '@arreeba/ristoranti-lib/lib/api';
import userAction from '@arreeba/ristoranti-lib/lib/action/user';
import orderAction from '@arreeba/ristoranti-frontend-lib/lib/actions/order';
import bookingAction from '@arreeba/ristoranti-frontend-lib/lib/actions/booking';
import voucherAction from '@arreeba/ristoranti-lib/lib/action/voucher';
import * as uxAction from './actions/ux';

const mapState = (state => state);
export const mapDispatchToProps = (dispatch) => {
  return {
    user: bindActionCreators(userAction, dispatch),
    app: bindActionCreators(appAction, dispatch),
    order: bindActionCreators(orderAction, dispatch),
    booking: bindActionCreators(bookingAction, dispatch),
    ux: bindActionCreators(uxAction, dispatch),
    voucher: bindActionCreators(voucherAction, dispatch),
  };
};

const apolloClientSelector = createSelector(
  state => state.app.bootstrap.api_endpoint,
  state => (state.user.currentUser && state.user.currentUser.accessToken),
  (apiUrl, token) => {
    const httpLink = createHttpLink({
      uri: apiUrl,
    });

    const link = new ApolloLink((operation, forward) => {
      // const token = getStoredToken();
      operation.setContext({
        headers: {
          authorization: token ? `Bearer ${token}` : null,
          'Accept-Language': 'it',
        },
      });
      return forward(operation);
    });

    return new ApolloClient({
      link: link.concat(httpLink),
      cache: new InMemoryCache(),
    });
  },
);

export const createApiInstance = (endpoint, accessToken) => {
  const api = Api(endpoint);
  api.setHeaders({
    'Authorization': 'Bearer ' + accessToken
  });

  return api;
};

export const serviceSelector = createSelector(
  state => state.app.bootstrap,
  state => (state.user.currentUser && state.user.currentUser.accessToken),
  (bootstrap, accessToken) => {
    const api = createApiInstance(bootstrap.api_endpoint, accessToken);

    return {
      app: curryApiToService(api, AppService(bootstrap.bundleId, 'WEB')),
      order: curryApiToService(api, OrderService),
      booking: curryApiToService(api, BookingService),
      user: curryApiToService(api, UserService),
      voucher: curryApiToService(api, VoucherService),
    };
  },
);

export const getTheme = props => _.property('app.config.theme')(props) || {};


export const connect = (Component, options = {}, extraProps) => {
  const componentMapState = options.mapStateToProps || mapState;

  const mapStateToProps = (state, props) => ({
    ...componentMapState(state, props),
    services: serviceSelector(state, props),
    apolloClient: apolloClientSelector(state, props),
  });

  const createProps = dispatch => ({
    actions: mapDispatchToProps(dispatch),
    dispatch,
    ...extraProps,
  });

  return reactReduxConnect(mapStateToProps, createProps)(Component);
};



// WEBPACK FOOTER //
// ./src/util.js